import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAuth} from '../contexts/AuthContext';
import {collection, getDocs, query, where} from 'firebase/firestore';
import {db} from '../firebase-config';
import {Box, Button, Typography} from '@mui/material';
import {Add as AddIcon} from '@mui/icons-material';
import '../styles/components/quiz-grid.css';
import QuizGrid from '../components/home/QuizGrid';

export default function MyQuizzes() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [quizzes, setQuizzes] = useState([]);

  useEffect(() => {
    const loadQuizzes = async () => {
      if (!currentUser) return;
      
      const q = query(
        collection(db, 'quizzes'),
        where('createdBy', '==', currentUser.uid)
      );
      
      const querySnapshot = await getDocs(q);
      const loadedQuizzes = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      setQuizzes(loadedQuizzes);
    };

    loadQuizzes();
  }, [currentUser]);

  const handleDelete = async (quizId) => {
    setQuizzes(quizzes.filter(quiz => quiz.id !== quizId));
  };

  return (
    <Box sx={{ p: 3, maxWidth: '1500px !important', mx: 'auto', width: '100%', px: { xs: 2, sm: 3, md: 4 } }}>
      <Box className="section-header" sx={{ mb: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography 
              component="h1" 
              className="section-title"
              sx={{ fontSize: '2.5rem !important' }}
            >
              Meine Quizze
            </Typography>
            <Typography className="section-subtitle">
              Verwalten Sie Ihre erstellten Quizze
            </Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => navigate('/quiz/create')}
          >
            Neues Quiz
          </Button>
        </Box>
      </Box>

      <QuizGrid 
        quizzes={quizzes} 
        showEditControls={true}
        onQuizDelete={handleDelete}
      />
    </Box>
  );
} 